import React, { useState } from "react";
import { API } from "aws-amplify";
import {
  Panel,
  Button
} from "react-bootstrap";
import "./CommunityBanner.css";

export default function CommunityBanner({
  props,
  community,
  setCommunity,
  updatingMembership,
  setUpdatingMembership,
  myCommunities,
  setMyCommunities
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isMember, setIsMember] = useState(props.user.communities && props.user.communities.includes(community.comm_id));

  function updateMembership() {
    if (!props.isAuthenticated) {
      props.history.push("/login?redirect=/communities/" + community.comm_id);
      return;
    } 
    setUpdatingMembership(true);

    let action;
    let newComms = props.user.communities ? [...props.user.communities] : [];
    if (isMember) { // is member -> leave comm
      const idx = newComms.indexOf(community.comm_id);
      newComms.splice(idx, 1);
      setIsMember(false);
      action = 'leave'
      setCommunity(Object.assign({}, community, {num_members: community.num_members - 1}));
      let index;
      myCommunities.forEach((comm, idx) => {
        if (comm.comm_id === community.comm_id)
          index = idx;
      });
      if (index > -1) {
        myCommunities.splice(index, 1);
        setMyCommunities(myCommunities);
      }
    } else { // not member -> join
      newComms.push(community.comm_id);
      setIsMember(true);
      action = 'join'
      const newComm = Object.assign({}, community, {num_members: community.num_members + 1});
      setCommunity(newComm);
      setMyCommunities([...myCommunities, newComm])
    }
    const data = {body: {
      "comm_id": community.comm_id,
      "action": action,
      'UID': props.user.UID
    }};
    API.post('comms', 'update_community', data).then(resp => {
      props.setUser(
        Object.assign({}, props.user, {
          communities: newComms
        })
      );
      setUpdatingMembership(false);
    });
  }

  function buttonText() {
    let buttonText = "join";
    if (isMember) {
      buttonText = "joined"
      if (isHovered) {
        buttonText = "leave :("
      }
    }
    return buttonText;
  }


  return (
    <Panel className={"community-banner"} style={{backgroundImage: `url(${community.banner_img ? community.banner_img : null})`}}>
      <Panel.Body style={{marginTop: '14%'}}>
        <div
          style={{ backgroundImage: `url(${community.img})` }}
          className="community-banner-image"
        />
        <div style={{display: 'flex'}}>
          <div className="community-banner-info">
            <h2 className="community-banner-name">
              { community.comm_name }
            </h2>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{marginRight: '10px'}}>
                { community.desc }
              </span>
              <div style={{width: '100px', marginRight: '10px'}}>
                <p className='text-muted community-banner-members'>
                  {`${community.num_members} members`}
                </p>
                <Button 
                  block
                  className={ `community-banner-button ${!isMember ? "normal" : "joined"}` }
                  onClick={updateMembership}
                  disabled={updatingMembership}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}  
                >
                  { buttonText() }
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Panel.Body>
    </Panel>
  );

}
